export default "__VITE_ASSET___jz9cyF9__"